import React from "react";
import {Link} from "react-router";
import Icon from "../Icon";
import svgPlace from "../../svgs/place.svg";
import svgOM from '../../svgs/om.svg';
import dollars from "../../dollar-format";
import SortTable from "../SortTable";
import {dateISOtoUS} from "../../date-converter";

function integer(value) {
    if (value === undefined || value === null || value === "") return "";
    return Math.round(Number(value)).toLocaleString();
}

function percent(value, withDecimals = true) {
    if (value === undefined || value === null || value === "") return "";
    if (withDecimals)
        return Number(value).toFixed(2) + "%";
    return parseInt(value) + "%";
}

const ListTable = (props) => {
    const {isSuper} = props;
    const query = props.location.query;
    const isHSC = query.SOURCE === 'HSC';
    const isClosed = query.CLOSE_OF_ESCROW_MIN || query.CLOSE_OF_ESCROW_MAX || query.STATUS === 'Closed,' || query.HSC_STATUS === 'Closed,';
    const isUnderContract = query.STATUS && query.STATUS === "Under Contract,";

    let columns = [{
        name: "",
        render: (el) => el,
    }];

    if (isHSC) {
        columns.push({
            code: "HSC_STATUS",
            name: "Status",
            render: (el) => el.HSC_STATUS,
        }, {
            code: "NAME",
            name: "Name",
            columnStyle: {minWidth: 250},
            render: (el) => {
                const name = el.NAME || "Untitled";
                return isSuper ? (
                    <Link
                        className="green"
                        to={{pathname: `${arc.path.base}property/${el.ARCIMEDES_ROW_ID}`}}>
                        {name}
                    </Link>
                ) : (
                    <a
                        href={`https://www.strivere.com/property/${el.ARCIMEDES_ROW_ID}`}
                        target="_blank">
                        {name}
                    </a>
                )
            },
        }, {
            name: "Map",
            textAlign: "center",
            render: (el) =>
                el.LONGITUDE && el.LATITUDE ? (
                    <Link target="_blank" to={arc.path.base + "map/" + el.ARCIMEDES_ROW_ID}>
                        <Icon svg={svgPlace}/>
                    </Link>
                ) : null,
        }, {
            code: "ADDRESS",
            name: "Address",
            columnStyle: {minWidth: 210},
            render: (el) =>
                el.ADDRESS ? (
                    <Link
                        target="_blank"
                        to={{
                            pathname: arc.path.base + "map/" + el.ARCIMEDES_ROW_ID,
                            query: {zoom: 18, mapTypeId: "satellite"},
                        }}
                    >
                        {el.ADDRESS}
                    </Link>
                ) : null,
        }, {
            code: "CITY",
            name: "City",
            columnStyle: {minWidth: 135},
            render: (el) => el.CITY,
        }, {
            code: "STATE",
            name: "State",
            textAlign: "center",
            render: (el) => el.STATE,
        });

        if (isClosed) {
            columns.push({
                code: "SOLD_PRICE",
                name: "Price at Close",
                textAlign: "center",
                render: (el) => dollars(el.SOLD_PRICE),
            }, {
                code: "CLOSE_CAP_RATE",
                name: "Close Cap Rate",
                textAlign: "center",
                render: (el) => percent(el.CLOSE_CAP_RATE),
            });
        }

        columns.push({
            code: "HSC_PRICE",
            name: "Price",
            textAlign: "center",
            render: (el) => dollars(el.HSC_PRICE),
        }, {
            code: "CAPITALIZATION_RATE",
            name: "Cap Rate",
            textAlign: "center",
            render: (el) => percent(el.CAPITALIZATION_RATE),
        }, {
            code: "LOAN_AMOUNT",
            name: "Loan Amount",
            textAlign: "center",
            render: (el) => dollars(el.LOAN_AMOUNT),
        }, {
            code: "LTV",
            name: "LTV",
            textAlign: "center",
            render: (el) => percent(el.LTV, false),
        }, {
            code: "DOWN_PAYMENT",
            name: "Down Payment",
            textAlign: "center",
            render: (el) => dollars(el.DOWN_PAYMENT),
        }, {
            code: "INTEREST_RATE",
            name: "Rate",
            textAlign: "center",
            render: (el) => percent(el.INTEREST_RATE),
        }, {
            code: "AMORTIZATION",
            name: "Amo",
            textAlign: "center",
            render: (el) => el.AMORTIZATION,
        }, {
            code: "TERM",
            name: "Term",
            textAlign: "center",
            render: (el) => el.TERM,
        }, {
            code: "LENDER_NAME",
            name: "Lender",
            columnStyle: {minWidth: 100},
            render: (el) => el.LENDER_NAME,
        });
    } else {
        if (isClosed) {
            columns.push({
                code: "CLOSE_OF_ESCROW",
                name: "Close of Escrow",
                render: (el) => el.CLOSE_OF_ESCROW ? dateISOtoUS(el.CLOSE_OF_ESCROW) : "",
            });
        }

        // check if filtered status is 'In Negotiation', 'Under Contract', or a combination of the two
        let isNegotiation = false;
        if (query.STATUS) {
            const status = query.STATUS.split(",");
            let count = 0;
            if (status.indexOf("In Negotiation") !== -1) {
                count++;
            }
            if (status.indexOf("Under Contract") !== -1) {
                count++;
            }
            if (count && count === status.length - 1) {
                isNegotiation = true;
            }
        }

        columns.push({
            code: "STATUS",
            name: "Status",
            render: (el) => el.STATUS,
        }, {
            name: "OM",
            render: (el) => el.MEDIA_KIT ?
                <Link target='_blank' to={arc.path.media + el.MEDIA_KIT}><Icon svg={svgOM}/></Link> : null,
        });

        if (isUnderContract) {
            columns.push({
                code: "EFFECTIVE_DATE",
                name: "Effective Date",
                render: (el) => el.EFFECTIVE_DATE ? dateISOtoUS(el.EFFECTIVE_DATE) : '',
            });
        }

        if (isSuper) {
            columns.push({
                code: "AGENT_1_LAST_NAME",
                name: "Agent",
                render: (el) => {
                    if (el.AGENT_1_LAST_NAME) {
                        return el.AGENT_1_LAST_NAME;
                    }
                    if (el.AGENT_2_LAST_NAME) {
                        return el.AGENT_2_LAST_NAME;
                    }
                    if (el.AGENT_3_LAST_NAME) {
                        return el.AGENT_3_LAST_NAME;
                    }
                    if (el.AGENT_4_LAST_NAME) {
                        return "OA";
                    }
                    return "";
                },
            });
        }

        columns.push({
            code: "CATEGORY",
            name: "Category",
            render: (el) =>
                el.CATEGORY ? el.CATEGORY[0].toUpperCase() + el.CATEGORY.slice(1) : "",
        });

        columns.push({
            code: "TYPE",
            name: "Type",
            render: (el) => el.TYPE,
        });

        columns.push({
            code: "NAME",
            name: "Name",
            columnStyle: {minWidth: 250},
            render: (el) => {
                const name = el.NAME || "Untitled";
                return isSuper ? (
                    <Link
                        className="green"
                        to={{pathname: `${arc.path.base}property/${el.ARCIMEDES_ROW_ID}`}}>
                        {name}
                    </Link>
                ) : (
                    <a
                        href={`https://www.strivere.com/property/${el.ARCIMEDES_ROW_ID}`}
                        target="_blank">
                        {name}
                    </a>
                )
            },
        });

        columns.push({
            name: "Map",
            textAlign: "center",
            render: (el) =>
                el.LONGITUDE && el.LATITUDE ? (
                    <Link target="_blank" to={arc.path.base + "map/" + el.ARCIMEDES_ROW_ID}>
                        <Icon svg={svgPlace}/>
                    </Link>
                ) : null,
        });

        columns.push({
            code: "ADDRESS",
            name: "Address",
            columnStyle: {minWidth: 210},
            render: (el) =>
                el.ADDRESS ? (
                    <Link
                        target="_blank"
                        to={{
                            pathname: arc.path.base + "map/" + el.ARCIMEDES_ROW_ID,
                            query: {zoom: 18, mapTypeId: "satellite"},
                        }}
                    >
                        {el.ADDRESS}
                    </Link>
                ) : null,
        });

        columns.push({
            code: "CITY",
            name: "City",
            columnStyle: {minWidth: 135},
            render: (el) => el.CITY,
        });

        columns.push({
            code: "STATE",
            name: "State",
            render: (el) => el.STATE,
        });

        if (!isClosed && !isNegotiation) {
            columns.push({
                code: "LIST_PRICE",
                name: "List Price",
                textAlign: "right",
                render: (el) => dollars(el.LIST_PRICE),
            });
            columns.push({
                code: "CAPITALIZATION_RATE",
                name: "Cap Rate",
                textAlign: "right",
                render: (el) => percent(el.CAPITALIZATION_RATE),
            });
        }

        if (isNegotiation) {
            columns.push({
                code: "NEGOTIATION_PRICE",
                name: "Price",
                textAlign: "right",
                render: (el) => dollars(el.NEGOTIATION_PRICE),
            });
            columns.push({
                code: "NEGOTIATION_CAP_RATE",
                name: "Cap Rate",
                textAlign: "right",
                render: (el) => percent(el.NEGOTIATION_CAP_RATE),
            });
        }

        if (isClosed) {
            columns.push({
                code: "SOLD_PRICE",
                name: "Price at Close",
                textAlign: "right",
                render: (el) => dollars(el.SOLD_PRICE),
            });
            columns.push({
                code: "CLOSE_CAP_RATE",
                name: "Close Cap Rate",
                textAlign: "right",
                render: (el) => percent(el.CLOSE_CAP_RATE),
            });
            columns.push({
                code: "CLOSE_NOI",
                name: "Close NOI",
                textAlign: "right",
                render: (el) => dollars(el.CLOSE_NOI),
            });
            columns.push({
                code: "LIST_PRICE",
                name: "List Price",
                textAlign: "right",
                render: (el) => dollars(el.LIST_PRICE),
            });
            columns.push({
                code: "CAPITALIZATION_RATE",
                name: "Cap Rate",
                textAlign: "right",
                render: (el) => percent(el.CAPITALIZATION_RATE),
            });
        } else {
            columns.push({
                code: "NET_OPERATING_INCOME",
                name: "NOI",
                textAlign: "right",
                render: (el) => dollars(el.NET_OPERATING_INCOME),
            });
        }

        if (isSuper) {
            columns.push({
                code: "SELLERS_LAST_NAME",
                name: "Seller",
                render: (el) => {
                    return el.SELLERS_LAST_NAME || "";
                },
            });
        }

        columns.push({
            code: "SQFT",
            name: "SQFT",
            textAlign: "right",
            render: (el) => integer(el.SQFT),
        });

        columns.push({
            code: "RENT_PER_SQFT",
            name: "Rent/SQFT",
            textAlign: "right",
            render: (el) => dollars(el.RENT_PER_SQFT, true),
        });

        if (isClosed) {
            columns.push({
                code: "CLOSE_PRICE_PER_SQFT",
                name: "Close PSF",
                textAlign: "right",
                render: (el) => dollars(el.CLOSE_PRICE_PER_SQFT),
            });
        } else if (isNegotiation) {
            columns.push({
                code: "NEGOTIATION_PRICE_PER_SQFT",
                name: "PSF",
                textAlign: "right",
                render: (el) => dollars(el.NEGOTIATION_PRICE_PER_SQFT),
            });
        } else {
            columns.push({
                code: "PRICE_PER_SQFT",
                name: "PSF",
                textAlign: "right",
                render: (el) => dollars(el.PRICE_PER_SQFT),
            });
        }

        if (query.TYPE === "STNL") {
            columns.push({
                code: "LEASE_EXPIRATION_DATE",
                name: "Remaining Term",
                render: (el) => {
                    if (el.LEASE_EXPIRATION_DATE) {
                        const ex = new Date(el.LEASE_EXPIRATION_DATE);
                        let diff;

                        if (el.STATUS && el.STATUS.toLowerCase() === "closed") {
                            const escrowDate = new Date(el.CLOSE_OF_ESCROW);
                            diff = ex - escrowDate;
                        } else {
                            const today = new Date();
                            diff = ex - today;
                        }

                        if (diff !== diff) {
                            // NaN
                            return "";
                        }

                        if (diff <= 0) {
                            return "Expired";
                        }

                        return (
                            Math.round((diff / (1000 * 60 * 60 * 24 * 365)) * 10) / 10 +
                            " years"
                        );
                    }

                    return "";
                },
            });

            columns.push({
                code: "LEASE_TYPE",
                name: "Lease",
                render: (el) => el.LEASE_TYPE,
            });
        }

        columns.push({
            code: "YEAR_BUILT",
            name: "Year Built",
            render: (el) => el.YEAR_BUILT,
        });

        if ((query.CATEGORY === "retail" || query.CATEGORY === "office") && query.TYPE === "MT") {
            columns.push({
                code: "VACANCY",
                name: "Occupancy",
                textAlign: "right",
                render: (el) => (el.VACANCY ? el.VACANCY + "%" : ""),
            });
        }
    }

    return (
        <div className="ListTable">
            <SortTable
                columns={columns}
                items={props.listings}
                query={query}
                classNameModifier="properties"
                toggleCheckbox={props.toggleCheckbox}
            />
        </div>
    );
};

export default ListTable;
